import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import {
    Button,
    Grid,
    InputAdornment,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    DialogActions,
    InputBase,
    Typography,
    CardContent,
    Card,
    Box
} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObjectIndex } from '../../../utils/utils';
import { getTripSuggestionSupplier, updateChatView, onlinePaymentsConfig } from '../../../store/actions/userActionCreators';
import { getVendorLedgerData } from '../../../store/actions/homeActionCreator';
import { getBankDetails, getPaymentLink,getPaymentInitiate } from '../../../store/actions/OnlinePaymentActionCreators';
import { getUserDetails } from '../../../store/actions/authActionCreators';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Form } from 'react-final-form';
import CloseIcon from '@material-ui/icons/Close';
import AmountInput from '../Inputs/AmountInput';
import { PaySupplierSideBarCss } from './RightSideBarCss';
import Highlighter from "react-highlight-words";
import SearchIcon from '@material-ui/icons/Search';
import { RightArrow } from '../TopCard/icons';
import AddIcon from '@material-ui/icons/Add';
import BankDetailsSelectionDialog from '../Bank/BankDetailsSelectionDialog';
import { VerifiedBankAccount, UnVerifiedBankAccount } from '../TopCard/icons';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import AddBankDetailsDialog from '../Bank/AddBankDetailsDialog';
import { trackDwebEvent } from '../../analytics';
import AddPhoneNumberDialog from '../Dialog/AddPhoneNumberDialog';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import DwebPaymentGateWayDialog from '../Dialog/DwebPaymentGateWayDialog';
const PaySupplierSideBar = ({
    rightSideBarOpen,
    toggleRightSideBar,
    dispatchChatView,
    dispatchGetTripSuggestionSupplier,
    dispatchGetVendorLedgerData,
    user,
    sideBarName,
    location,
    calledFromFlow,
    dispatchGetBankDetails,
    dispatchGetPaymentLink,
    tripDetailSingleTrip,
    dispatchGetOnlinePaymentsConfig,
    dispatchGetUserDetails,
    dispatchGetPaymentInitiate
}) => {

    let submit, tripSubmit, tripEditSubmit, payOnlineSubmit;
    const locationDetails = useLocation();
    const path = locationDetails && locationDetails.pathname ? locationDetails.pathname.split("/") : [];
    const vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = PaySupplierSideBarCss();

    const [dialogOpen, setDialogOpen] = useState(rightSideBarOpen);
    const [checkedTrips, setCheckedTrips] = useState([]);
    const [trips, setTrips] = React.useState([]);
    const [tripKey, setTripKey] = React.useState(null);
    const [fullyAllocted, setFullyAllocted] = useState(false);
    const [allocatedText, setAllocatedText] = useState("");
    const [selectedForEdit, setSelectedForEdit] = React.useState(null);
    const [selectedAmount, setSelectedAmount] = React.useState(0);
    const [tripAmountEditOpen, setTripAmountEditOpen] = React.useState(false);
    const [dialogConfirmDisabled, setDialogConfirmDisabled] = useState(false);
    const [searchTxt, setSearchTxt] = useState("");
    const [vendorLedger, setVendorLedger] = useState([]);
    const [screen, setScreen] = useState("");
    const [allocatedAmountTotal, setAllocatedAmountTotal] = useState(0);
    const [checkboxChange, setCheckboxChange] = useState(false);
    const [payOnlineDisabled, setPayOnlineDisabled] = useState(true);
    const [selectedVendor, setSelectedVendor] = useState({});
    const [payNowDisabled, setPayNowDisabled] = useState(true);
    const [tripsSelected, setTripsSelected] = useState([]);
    const [backFlag, setBackFlag] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [selectBank, setSelectBank] = useState(false);
    const [addBankDetails, setAddBankDetails] = useState(false)
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [amountPayOnline, setAmountPayOnline] = useState("");
    const [payOnlineError, setPayOnlineError] = useState(true);
    const [configInfo, setConfigInfo] = useState({});
    const [addPhoneNumber, setAddPhoneNumber] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [transactionLimitValue, setTransactionLimitValue] = useState(0);
    const [addSupplierOpen, toggleAddSupplierOpen] = React.useState(false);
    const [recall,setRecall] = useState(false);

    //Payment GateWay
  const [customPGOpen, setCustomPGOpen] = useState(false);
  const [cashFreeOrderData,setCashFreeOrderData] = useState(null);
  const [orderRequestData,setOrderRequestData] = useState(null);

  const handleAddSupplierClose = () => {
    toggleAddSupplierOpen(false);
  };
  const handleAddSupplierOpen = () => {
    toggleAddSupplierOpen(true);
  };
  const handleSupplierSave = (status, response) => {
    toggleAddSupplierOpen(false);
    setRecall(!recall)
  }
    const initialTripValues = {
        trips: trips,
    }

    let initialTripAmountValues = {
        amount: selectedAmount ? selectedAmount : ""
    }

    let initialPayOnlineAmount = {
        amountPayOnline: amountPayOnline ? amountPayOnline : ""
    }

    useEffect(() => {

        if (user && user.userInfoProfile) {
            setUserInfo(user.userInfoProfile);
        }

    }, [user.userInfoProfile])

    useEffect(() => {
        setTimeout(() => {
            if (checkedTrips && checkedTrips.length > 0) {

                for (var i = 0; i < checkedTrips.length; i++) {

                    if (trips.includes(checkedTrips[i].tripId)) {

                        if (Number(checkedTrips[i].attributionAmount) == Number(checkedTrips[i].tripBalance)) {

                            document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #0033cc';
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #0033cc !important'

                        } else
                            if (Number(checkedTrips[i].attributionAmount) < Number(checkedTrips[i].tripBalance)) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #e8843c';

                                var arr = [document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')];

                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #e8843c !important'
                                }
                            }
                    } else {
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].style = 'border: none !important';
                        }
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0].removeAttribute("style");
                        }
                    }
                }

            }
        }, 90)


    }, [checkedTrips, trips, backFlag ]);

    useEffect(() => {
        dispatchChatView(false);

        if (calledFromFlow == "singleTrip") {

            loadBanKList();
            setScreen("payOnline");
            setSelectedVendor(tripDetailSingleTrip && tripDetailSingleTrip.vendor ? tripDetailSingleTrip.vendor : {});

        } else if (calledFromFlow == "onlinePayments") {

            setScreen("selectSupplier");

            const vendorData = {
                pageNo: 1,
                pageSize: 100,
                fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
            }

            dispatchGetVendorLedgerData(vendorData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Pay Supplier Side Bar Dweb', "Get Vendor List Successfull");
                        trackDwebEvent('Dweb Online Payments supplier listing page', {});
                        if (data && data.response && data.response.vendors && data.response.vendors.length > 0) {
                            setVendorLedger(data.response.vendors)
                        }
                    }
                },
                () => {
                    logger.log('Pay Supplier Side Bar Dweb', "Get Vendor List Failed");
                }
            );

        } else if (calledFromFlow == "singleSupplier") {

            setScreen("chooseTrips");

            const suggestionData = {
                vendorId: vendorIdValue,
                paymentAmount: 0
            }

            dispatchGetUserDetails(
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Pay Supplier Side Bar Dweb', 'Fetch User Details Successfull');
                        dispatchGetOnlinePaymentsConfig(
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log('Pay Supplier Side Bar Dweb', 'Get Online Payments Config Successfull');

                                    dispatchGetTripSuggestionSupplier(suggestionData,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Trips Suggestion Trips Successfull.');
                                                trackDwebEvent('Dweb single supplier payout initiated', {
                                                    vendor_id: vendorIdValue ? vendorIdValue : "",
                                                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                                                    // vendor_contact_number, 
                                                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0
                                                });
                                                if (data.response) {
                                                    let defaultTrips = [];
                                                    data.response.forEach(trip => {
                                                        if (trip && trip.attributionAmount && Number(trip.attributionAmount) != 0) {
                                                            defaultTrips.push(trip.tripId)
                                                        }
                                                    });
                                                    setTrips(defaultTrips);
                                                    setCheckedTrips(data.response);
                                                }
                                            }
                                        },
                                        (data) => {
                                            logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Trips Suggestion Trips Failed.')
                                            trackDwebEvent('Dweb single supplier payout trip selection failed', {
                                                vendor_id: vendorIdValue ? vendorIdValue : "",
                                                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                                                // vendor_contact_number, 
                                                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                                                supplier_payout_amount: 0,
                                                count_of_trips: 0,
                                                failure_reason: data && data.status && data.status.message ? data.status.message : ""
                                            });
                                        }
                                    );

                                }
                            },
                            () => {
                                logger.log('Pay Supplier Side Bar Dweb', 'Get Online Payments Config Failed');
                            }
                        );
                    }
                },
                () => {
                    logger.log('Pay Supplier Side Bar Dweb', 'Fetch User Details Failed');
                }
            );

        }
    }, [rightSideBarOpen,recall]);

    useEffect(() => {

        if (user && user.onlinePaymentConfig) {
            setConfigInfo(user.onlinePaymentConfig);
        } else {
            setConfigInfo({});
        }

    }, [user.onlinePaymentConfig]);

    const handleClose = () => {

        setConfigInfo({});

        let finalBank = bankList.filter(v => v && v.is_default);
        let mixpanelData = {}

        if (calledFromFlow == "singleTrip") {

            mixpanelData.bankId = finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : "";
            mixpanelData.payoutAmount = amountPayOnline ? amountPayOnline : "";

            trackDwebEvent('Dweb STP Supplier payout form page cancelled', {
                trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : "",
                supplier_payout_amount: amountPayOnline ? amountPayOnline : "",
                bank_account_id: finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : ""
            })
        } else if (calledFromFlow == "singleSupplier") {

            mixpanelData.bankId = finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : "";
            mixpanelData.payoutAmount = amountPayOnline ? amountPayOnline : "";
            mixpanelData.tripCount = trips ? trips.length : 0

            if (screen == "chooseTrips") {
                trackDwebEvent("Dweb single supplier payout trip selection cancelled", {
                    vendor_id: vendorIdValue ? vendorIdValue : "",
                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                    // vendor_contact_number: , 
                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                    supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                    count_of_trips: trips ? trips.length : 0
                });
            } else if (screen == "payOnline") {
                trackDwebEvent('Dweb single supplier payout form page cancelled', {
                    vendor_id: vendorIdValue ? vendorIdValue : "",
                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                    // vendor_contact_number: , 
                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                    supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                    count_of_trips: trips ? trips.length : 0
                });
            }

        }


        toggleRightSideBar(mixpanelData);
        setDialogOpen(false);
        dispatchChatView(true);
    }


    // ************************************** Choose trips screen functions and components . ************************************** 
    const getTripFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV5}>
                            <div className={classes.checkBoxLabel}>Select Trips</div>
                            <Checkboxes
                                name="trips"
                                onChange={(e) => {
                                    setCheckboxChange(true);
                                    let tripValues = [...trips];
                                    let selectedTrips = [];

                                    let selected = [...checkedTrips];
                                    let index = findArrayObjectIndex('tripId', Number(e.target.value), selected);
                                    selected[index].attributionAmount = selected[index] && selected[index].tripBalance ? selected[index].tripBalance : 0;
                                    selectedTrips.push(selected[index]);
                                    setCheckedTrips(selected);

                                    if (tripValues.includes(Number(e.target.value))) {
                                        tripValues = tripValues.filter(function (value, index, arr) {
                                            return value != Number(e.target.value);
                                        });
                                    } else {
                                        tripValues.push(Number(e.target.value));
                                    }
                                    tripsSelected.push(selectedTrips);
                                    setTrips([...new Set(tripValues)])
                                }}
                                formControlProps={{
                                    margin: 'none',
                                    className: classes.checkboxInput
                                }}
                                formControlLabelProps={{
                                    className: classes.checkboxTripLabel
                                }}
                                formLabelProps={{
                                    className: classes.checkBoxLabel
                                }}
                                formGroupProps={{
                                    className: 'form-group-checkbox'
                                }}
                                classes={{ checked: classes.checkBoxChecked }}
                                data={getTripsSelection(values)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const getTripsSelection = (values) => {
        let trips = [];
        if (checkedTrips && Array.isArray(checkedTrips)) {
            for (const key in checkedTrips) {
                if (Object.hasOwnProperty.call(checkedTrips, key)) {
                    const tripData = checkedTrips[key];
                    tripData.value = tripData.tripId;
                    tripData.label = (
                        <div className={classes.mlV1} >
                            <Grid container wrap="nowrap" justify="space-between" >
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidthV1 }}>
                                    <Grid item className={classes.gridRoute}>
                                        <span>{tripData && tripData.startLocation ? tripData.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParam}>
                                        {tripData && tripData.params.length > 0 && tripData.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != tripData.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV1} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidth }}>
                                    {values && values.trips && !values.trips.includes(tripData.tripId) &&
                                        <Grid item className={classes.tripBalance} >
                                            {tripData && tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}
                                        </Grid>
                                    }
                                    {values && values.trips && values.trips.includes(tripData.tripId) &&
                                        <>
                                            <Grid container wrap="nowrap" alignItems="center" classes={{ container: classes.containerWidth }} >
                                                <Grid item className={classes.gridItemV1}>
                                                    <TextField
                                                        name={'attributionAmount-' + tripData.tripId}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth={false}
                                                        value={tripData.attributionAmount ?  numberFormat(tripData.attributionAmount) : 0}
                                                        margin="none"
                                                        onClick={(e) => {
                                                            handleTripAmountClick(e, key);
                                                        }}
                                                        className={classes.cardInput}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <div className={Number(tripData.attributionAmount) < Number(tripData.tripBalance) ? classes.divAlignV1 : classes.divAlign} >
                                                        <div className={classes.marginV1} >/</div>
                                                        <div>{tripData.tripBalance ? numberFormat(tripData.tripBalance) : ""}</div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item className={classes.gridItemStatus} >
                                                {Number(tripData.attributionAmount) == Number(tripData.tripBalance) &&
                                                    <div className={classes.divBox}>
                                                        Full Payment
                                                    </div>
                                                }
                                                {Number(tripData.attributionAmount) < Number(tripData.tripBalance) &&
                                                    <div className={classes.divBoxPart}>
                                                        Part Payment
                                                    </div>
                                                }
                                            </Grid>
                                        </>
                                    }

                                </Grid>
                            </Grid>
                        </div >
                    )

                    trips.push(tripData);
                }

            }
        }

        return trips;
    }

    const onTripSubmit = values => {

    }

    const tripValidate = values => {

        let errors = [];

        let allocatedAmount = 0;
        let totalTripBalance = 0;
        let transactionLimit = 0;

        checkedTrips.map((tripData) => (
            totalTripBalance += tripData && tripData.tripBalance ? tripData.tripBalance : 0
        ));

        for (var i = 0; i < values.trips.length; i++) {
            let filteredTrip = checkedTrips.filter((tripData) => tripData.tripId == (values && values.trips[i] ? values.trips[i] : ""))
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (userInfo) {
            if (!userInfo.isKYCVerified && !userInfo.isPaymentsWhitelisted) {
                transactionLimit = configInfo && configInfo.transactionLimit ? configInfo.transactionLimit : 0;
            } else if (userInfo.isPaymentsWhitelisted && !userInfo.isKYCVerified) {
                transactionLimit = configInfo && configInfo.whiteListedUserTransactionLimit ? configInfo.whiteListedUserTransactionLimit : 0;
            } else if (userInfo.isKYCVerified) {
                transactionLimit = configInfo && configInfo.KycUserTransactionLimit ? configInfo.KycUserTransactionLimit : 0;
            }
        }

        if (values.trips.length == 0) {
            setPayOnlineDisabled(true);
        } else {
            setPayOnlineDisabled(false);
        }

        setAllocatedAmountTotal(allocatedAmount);
        setTransactionLimitValue(transactionLimit);

        return errors;
    }
    // ************************************** Choose trips screen functions and components end. ************************************** 


    // ******************************************** Edit Amount Dialog Actions and Functions. ********************************************
    const handleTripAmountClick = (e, key) => {
        if (checkedTrips) {
            setTripKey(key);
            setSelectedForEdit(checkedTrips[key]);
            // setSelectedAmount(e.target.value);
            setSelectedAmount(checkedTrips && checkedTrips[key] && checkedTrips[key].attributionAmount ? checkedTrips[key].attributionAmount : 0);
            setTripAmountEditOpen(true);
        }
    }

    const handleEditAmountClose = () => {
        setTripKey(null);
        setSelectedForEdit(null);
        setSelectedAmount(null);
        setTripAmountEditOpen(false);
    }

    const onTripEditSubmit = values => {
        if (Object.keys(editAmountValidate(initialTripAmountValues)).length == 0) {
            let values = [...checkedTrips];
            values[tripKey].attributionAmount = replaceCommas(selectedAmount);
            setCheckedTrips(values);
            setTripKey(null);
            setSelectedForEdit(null);
            setSelectedAmount(null);
            setTripAmountEditOpen(false);
            trackDwebEvent('Dweb single supplier payout trip amount changed', {
                vendor_id: vendorIdValue ? vendorIdValue : "",
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number: , 
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                count_of_trips: trips ? trips.length : "",
                trip_id: selectedForEdit && selectedForEdit.tripId ? selectedForEdit.tripId : "",
                trip_supplier_balance: selectedForEdit && selectedForEdit.tripBalance ? selectedForEdit.tripBalance : "",
                trip_supplier_payout_amount: selectedForEdit && selectedForEdit.attributionAmount ? selectedForEdit.attributionAmount : ""
            })
        }
    }

    const editAmountValidate = values => {
        const errors = {};

        if (values && !values.amount) {
            setDialogConfirmDisabled(true);
        } else {
            if (values.amount && !validNumberCheck(values.amount)) {
                errors.amount = "Invalid Amount"
                setDialogConfirmDisabled(true);
            }else if (Number(values.amount ? replaceCommas(values.amount) : 0)%1!=0) {
                errors.amount = "Invalid Amount"
                setDialogConfirmDisabled(true);
            }else if (Number(values.amount ? replaceCommas(values.amount) : 0) > Number(selectedForEdit && selectedForEdit.tripBalance ? replaceCommas(selectedForEdit.tripBalance) : 0)) {
                errors.amount = "Amount cannot be greater than " + selectedForEdit.tripBalance
                setDialogConfirmDisabled(true);
            } else {
                setDialogConfirmDisabled(false);
            }
        }

        return errors;
    }

    const getAmountFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAmountContainer} >
                        <div className={classes.titleV3}>Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setSelectedAmount(e.target.value)
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            className={classes.mtV4}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            }
        ]
    }
    // *************************************  Edit Amount Dialog Actions and Functions End.  *************************************


    const handleSupplierSelect = (vendor) => {

        setSelectedVendor(vendor);

        const suggestionData = {
            vendorId: vendor.id,
            paymentAmount: 0
        }

        trackDwebEvent('Dweb Online Payments supplier selected', {
            supplier_name: vendor && vendor.name ? vendor.name : "",
            supplier_id: vendor && vendor.id ? vendor.id : ""
        });


        dispatchGetUserDetails(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Pay Supplier Side Bar Dweb', 'Fetch User Details Successfull');
                    dispatchGetOnlinePaymentsConfig(
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('Pay Supplier Side Bar Dweb', 'Get Online Payments Config Successfull');
                                dispatchGetTripSuggestionSupplier(suggestionData,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Trips Suggestion Trips Successfull.');
                                            if (data.response) {
                                                let defaultTrips = [];
                                                data.response.forEach(trip => {
                                                    if (trip && trip.attributionAmount && Number(trip.attributionAmount) != 0) {
                                                        defaultTrips.push(trip.tripId)
                                                    }
                                                });
                                                setTrips(defaultTrips);
                                                setCheckedTrips(data.response);
                                                setScreen("chooseTrips");
                                            }
                                        }
                                    },
                                    () => {
                                        logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Trips Suggestion Trips Failed.')
                                    }
                                );
                            }
                        },
                        () => {
                            logger.log('Pay Supplier Side Bar Dweb', 'Get Online Payments Config Failed');
                        }
                    );
                }
            },
            () => {
                logger.log('Pay Supplier Side Bar Dweb', 'Fetch User Details Failed');
            }
        );
    }

    const handleBackClick = () => {
        setScreen("selectSupplier");
    }

    const handlePayOnlineClick = () => {
        loadBanKList();
        if (calledFromFlow == "singleSupplier") {
            setSelectedVendor({
                id: vendorIdValue,
                name: location && location.state && location.state.pageTitle ? location.state.pageTitle : ""
            });
        }
    }


    const handlePayOnlineBackClick = () => {
        setScreen("chooseTrips");
        setBackFlag(!backFlag);
    }

    const handlePayNowClick = () => {

        let mobileNumber;

        if (calledFromFlow == "singleTrip") {
            mobileNumber = tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorNumber ? tripDetailSingleTrip.vendor.vendorNumber : "";
        } else if (calledFromFlow == "singleSupplier") {
            mobileNumber = user && user.singleVendorNumber ? user.singleVendorNumber : "";
        } else if (calledFromFlow == "onlinePayments") {
            mobileNumber = selectedVendor && selectedVendor.vendorNumber ? selectedVendor.vendorNumber : "";
        }

        // Checking vendor phone number. 
        if (mobileNumber) {
            payNowCall();
        } else {
            setAddPhoneNumber(true);
        }

    }


    const payNowCall = () => {

        let finalBank = bankList.filter(v => v && v.is_default);
        const filtered = [];

        for (var i = 0; i < trips.length; i++) {
            const selectedData = checkedTrips.find(tripData => tripData.tripId == trips[i]);
            filtered.push({
                amount: selectedData.attributionAmount,
                tripId: selectedData.tripId
            })
        }

        if (finalBank && finalBank.length > 0 && finalBank[0] && finalBank[0].id) {

            let reqData = {
                "bankId": `${finalBank[0].id}`,
                "payerType": "USER",
                "payeeType": "SUPPLIER",
                "payments": filtered,
                "payerId": user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                "payeeId": selectedVendor && selectedVendor.id ? selectedVendor.id : "",
                "paymentView": "web_v2",
                "returnUrl": `${calledFromFlow == "singleSupplier"?window.location.href.replace("trips", "passbook"):window.location.href}`
            }

            if (calledFromFlow == "singleTrip") {
                reqData.payeeId = tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : ""
                reqData.payments = [{
                    amount: replaceCommas(amountPayOnline),
                    tripId: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : ""
                }]
            }

            dispatchGetPaymentInitiate(reqData, (data) => {
                if (data && data.status && data.status.code == 200 && data.response) {
                    setOrderRequestData({
                      ...reqData,
                      orderAmount: data.response.orderAmount,
                      selectedVendor:selectedVendor,
                      finalBank:finalBank[0],
                      returnUrl: `${calledFromFlow == "singleSupplier"?window.location.href.replace("trips", "passbook"):window.location.href}`
                    });
                    setCashFreeOrderData(data.response);
                    setCustomPGOpen(true)
                    //handleClose(true)
                }else{
                  handleClose(true)
                }
                /*if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
                    if (calledFromFlow == "singleTrip") {
                        trackDwebEvent('Dweb STP Supplier payout form page successful', {
                            trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                            trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                            supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                            supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                            trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                            vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                            vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                            origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                            destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                            supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : "",
                            supplier_payout_amount: amountPayOnline ? amountPayOnline : "",
                            bank_account_id: finalBank[0].id
                        })
                    } else if (calledFromFlow == "singleSupplier") {
                        trackDwebEvent('Dweb single supplier payout form page successful', {
                            vendor_id: vendorIdValue ? vendorIdValue : "",
                            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                            // vendor_contact_number: , 
                            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                            supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                            count_of_trips: trips ? trips.length : 0,
                            bank_account_id: finalBank[0].id,
                        })
                    }
                    window.location.href = data.response.paymentLink;
                    handleClose();
                }*/
            }, (data) => {
                // handleClose();
                if (calledFromFlow == "singleTrip") {
                    trackDwebEvent('Dweb STP Supplier payout form page failed', {
                        trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                        trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                        supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                        supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                        trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                        vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                        vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                        origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                        destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                        supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : "",
                        supplier_payout_amount: amountPayOnline ? amountPayOnline : "",
                        bank_account_id: finalBank[0].id,
                        error_reason: data && data.status && data.status.message ? data.status.message : ""
                    })
                } else if (calledFromFlow == "singleSupplier") {
                    trackDwebEvent('Dweb single supplier payout form page failed', {
                        vendor_id: vendorIdValue ? vendorIdValue : "",
                        vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                        // vendor_contact_number: , 
                        vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                        supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                        count_of_trips: trips ? trips.length : 0,
                        bank_account_id: finalBank[0].id,
                        failure_reason: data && data.status && data.status.message ? data.status.message : ""
                    })
                }
            })
        }

    }

    const addPhoneNumberDialogClose = () => {
        setAddPhoneNumber(false);
    }

    const addPhoneNumberDialogConfirm = () => {
        setAddPhoneNumber(false);
        payNowCall();
    }

    // ************************************ Select Bank ************************************.
    const handleSelectBankOpen = () => {
        setSelectBank(true);
    }

    const handleSelectBankClose = () => {
        setSelectBank(false)
    }

    const handleSelectBankSave = (status) => {
        if (status) {
            loadBanKList()
        }
        setSelectBank(false)
    }

    const loadBanKList = () => {

        const requestData = {
            type: "SUPPLIER",
            id: selectedVendor && selectedVendor.id ? selectedVendor.id : ""
        }

        if (calledFromFlow == "singleSupplier") {
            requestData.id = vendorIdValue
        }

        if (calledFromFlow == "singleTrip") {
            requestData.id = tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : ""
        }

        dispatchGetBankDetails(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Bank Details Successfull');

                    if (calledFromFlow == "singleTrip") {
                        trackDwebEvent('Dweb STP Supplier payout form page', {
                            trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                            trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                            supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                            supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                            trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                            vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                            vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                            origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                            destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                            supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : ""
                        })
                    } else if (calledFromFlow == "singleSupplier") {
                        trackDwebEvent('Dweb single supplier payout form page', {
                            vendor_id: vendorIdValue ? vendorIdValue : "",
                            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                            // vendor_contact_number, 
                            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                            supplier_payout_amount: allocatedAmountTotal ? allocatedAmountTotal : 0,
                            count_of_trips: trips ? trips.length : ""
                        });
                    }

                    setScreen("payOnline");
                    setBankList(data && data.response ? data.response : []);
                    if (data.response) {
                        if (data && data.response && data.response.length > 0) {
                            // if (data.response.some((bankData) => bankData.broker_verification_status == true)) {
                            //     setPayNowDisabled(false);
                            // } else {
                            //     setPayNowDisabled(true);
                            // }
                            // for (var i = 0; i < data.response.length; i++) {
                            //     if (data.response[i] && data.response[i].broker_verification_status) {
                            //         setPayNowDisabled(false);
                            //     }
                            // }

                            const defaultBank = data.response.filter((bankData) => bankData.is_default == true);
                            if (defaultBank && defaultBank[0]) {
                                setPayNowDisabled(defaultBank[0].broker_verification_status ? false : true);
                            }

                        } else {
                            setPayNowDisabled(true);
                        }
                    }
                }
            },
            () => {
                logger.log('Pay Supplier Side Bar Dweb', 'Get Supplier Bank Details Failed');
            }
        )

    }
    // ************************************ Select Bank End ************************************.

    // ************************************ Add Bank ************************************.
    const handleAddBankClose = () => {
        setAddBankDetails(false)
    }

    const handleAddBankSave = (status) => {
        if (status) {
            handleSuccessOpen()
            setTimeout(() => {
                handleSuccessClose()
            }, 3000);
        } else {
            handleFailureOpen()
            setTimeout(() => {
                handleFailureClose()
            }, 3000);
        }
        loadBanKList()
        setAddBankDetails(false)
    }

    const handleAddBankOpen = () => {
        setAddBankDetails(true);
        if (calledFromFlow == "singleTrip") {
            trackDwebEvent('Dweb STP Supplier payout add bank account initiated', {
                trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : ""
            })
        } else if (calledFromFlow == "singleSupplier") {
            trackDwebEvent('Dweb single supplier payout add bank account initiated', {
                vendor_id: vendorIdValue ? vendorIdValue : "",
                vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                // vendor_contact_number, 
                vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
            });
        }
    }
    const handleCustomPGClose = () => {
        setCustomPGOpen(false);
        setOrderRequestData(null);
        setCashFreeOrderData(null);
        //handleClose(true)
    }
    const handleCustomPGConfirm = () => {
        setCustomPGOpen(false);
        setOrderRequestData(null);
        setCashFreeOrderData(null);
        handleClose(true)
    }
    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }

    const handleSuccessClose = () => {
        setSuccessCreation(false)
    }

    const handleFailureOpen = () => {
        setFailureCreation(true)
    }

    const handleFailureClose = () => {
        setFailureCreation(false)
    }
    // ************************************ Add Bank End ************************************.


    // ************************************ Amount field when called from single trip ************************************.
    const getFormFieldAmount = values => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAmountContainer} >
                        <div className={classes.titleV3}>Amount to Send</div>
                        <AmountInput
                            placeholder="Enter amount to Send"
                            name="amountPayOnline"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setAmountPayOnline(e.target.value)
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            className={classes.mtV4}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            }
        ]
    }

    const payOnlineAmountValidate = values => {
        const errors = {};

        let transactionLimit = 0;
        let isGreaterThanTransactionLimit = false;

        if (userInfo) {
            if (!userInfo.isKYCVerified && !userInfo.isPaymentsWhitelisted) {
                transactionLimit = configInfo && configInfo.transactionLimit ? configInfo.transactionLimit : 0;
            } else if (userInfo.isPaymentsWhitelisted && !userInfo.isKYCVerified) {
                transactionLimit = configInfo && configInfo.whiteListedUserTransactionLimit ? configInfo.whiteListedUserTransactionLimit : 0;
            } else if (userInfo.isKYCVerified) {
                transactionLimit = configInfo && configInfo.KycUserTransactionLimit ? configInfo.KycUserTransactionLimit : 0;
            }
        }

        if (tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance > transactionLimit) {
            isGreaterThanTransactionLimit = true;
        } else if (tripDetailSingleTrip && (tripDetailSingleTrip.vendorBalance < transactionLimit || tripDetailSingleTrip.vendorBalance == transactionLimit)) {
            isGreaterThanTransactionLimit = false;
        }

        if (values && !values.amountPayOnline) {
            errors.amountPayOnline = "Please enter amount."
        }

        /*if (values && values.amountPayOnline && Number(replaceCommas(values.amountPayOnline)) > Number(isGreaterThanTransactionLimit ? transactionLimit : tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : 0)) {
            errors.amountPayOnline = "Amount cannot be greater than " + numberFormat(isGreaterThanTransactionLimit ? transactionLimit : tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : 0);
        }*/

        if (errors && !errors.amountPayOnline && values.amountPayOnline) {
            setPayOnlineError(false);
        } else if (errors && errors.amountPayOnline) {
            setPayOnlineError(true);
        }

        return errors;
    }

    const payOnlineAmountSubmit = values => {
    }

    // ************************************ Amount field when called from single trip End. ************************************.

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>

                        {screen == "selectSupplier" &&
                            <>
                                Select Supplier
                            </>
                        }
                        {screen == "chooseTrips" &&
                            <>
                                Choose Trips
                            </>
                        }
                        {screen == "payOnline" &&
                            <>
                                Pay Online
                            </>
                        }

                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    {screen == "selectSupplier" &&
                        <>  
                            {vendorLedger && vendorLedger.length == 0 &&<div className={classes.emptyStateDiv}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/supplier-list-empty-state.svg`} alt="Empty State Image" />
                            <Typography className={classes.emptyTxt}>Add Suppliers and Create Trips to Send Money Online</Typography>
                            </div>}
                            {vendorLedger && vendorLedger.length > 0 &&<div>
                                <div className={classes.search}>
                                    {!searchTxt && <div className={classes.searchIcon}>
                                        <SearchIcon className={classes.sicon} />
                                    </div>}
                                    {searchTxt && <div className={classes.closeIcon} onClick={(e) => { setSearchTxt("") }}>
                                        <CloseIcon className={classes.sicon} />
                                    </div>}
                                    <InputBase
                                        placeholder="Search for Supplier"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        onChange={(e) => { setSearchTxt(e.target.value) }}
                                        value={searchTxt}
                                        inputProps={{ 'aria-label': 'search' }}
                                    />
                                </div>
                                <div className={classes.listingDiv}>
                                    <div className={classes.subTitleSec} >
                                        <Typography className={classes.subTitleTxt}>Supplier Name</Typography>
                                        <Typography className={classes.subTitleTxt}>Balance</Typography>
                                    </div>
                                    {vendorLedger && vendorLedger.length > 0 && vendorLedger.filter(vendor => {
                                        return vendor && vendor.name.toLowerCase().indexOf(searchTxt.toLowerCase()) >= 0;
                                    }).map((vendor) => {
                                        return (
                                            <>
                                                {vendor && vendor.vendorBalance != 0 &&
                                                    <div className={classes.vendorDiv} onClick={(e) => { handleSupplierSelect(vendor) }}>
                                                        <div className={classes.nameDiv}>
                                                            <Typography className={classes.listDriverName}>
                                                                <Highlighter
                                                                    highlightClassName={classes.highlight}
                                                                    searchWords={[searchTxt]}
                                                                    autoEscape={true}
                                                                    textToHighlight={vendor && vendor.name ? vendor.name : ""}
                                                                />
                                                            </Typography>
                                                        </div>
                                                        <div className={classes.balanceDiv} >
                                                            <Typography className={classes.vendorBalance}>{numberFormat(vendor.vendorBalance ? vendor.vendorBalance : 0)}</Typography>
                                                            <RightArrow className={classes.listRightIcon} />
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        )
                                    })}
                                </div>
                            </div>}
                        </>
                    }

                    {screen == "chooseTrips" &&
                        <>
                            <div className={classes.divContainerBox}>
                                <div className={classes.divTitleV1}>Supplier Name</div>
                                <div className={classes.divText}>{selectedVendor && selectedVendor.name ? selectedVendor.name : user && user.singleVendorPageName ? user.singleVendorPageName : ""}</div>
                            </div>
                            <div>
                                <Form
                                    onSubmit={onTripSubmit}
                                    initialValues={initialTripValues}
                                    validate={tripValidate}
                                    render={({ handleSubmit, form, submitting, pristine, values }) => {
                                        tripSubmit = handleSubmit; return (
                                            <form onSubmit={handleSubmit} noValidate>
                                                <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                                    {getTripFormFields(values).map((item, idx) => item.visible ? (
                                                        <Grid item xs={item.size} key={idx}>
                                                            {item.field}
                                                        </Grid>
                                                    ) : null)}
                                                </Grid>
                                            </form>
                                        )
                                    }}
                                />
                            </div>
                        </>
                    }

                    {screen == "payOnline" &&
                        <>
                            <Grid container wrap="nowrap" justify="space-between" className={classes.gridContainerV1}>
                                <Grid item>
                                    <div className={classes.divTitleV1}>Supplier Name</div>
                                    <div className={classes.divText}>{tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : selectedVendor && selectedVendor.name ? selectedVendor.name : user && user.singleVendorPageName ? user.singleVendorPageName : ""}</div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.divTitleV2}>
                                        {calledFromFlow != "singleTrip" &&
                                            <>
                                                Total Amount
                                            </>
                                        }
                                        {calledFromFlow == "singleTrip" &&
                                            <>
                                                Supplier Trip Balance
                                            </>
                                        }
                                    </div>
                                    <div className={classes.divTextV1}>{calledFromFlow == "singleTrip" && tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? numberFormat(tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : 0) : numberFormat(allocatedAmountTotal ? allocatedAmountTotal : 0)}</div>
                                </Grid>
                            </Grid>

                            {calledFromFlow == "singleTrip" &&
                                <div>
                                    <Form
                                        onSubmit={payOnlineAmountSubmit}
                                        initialValues={initialPayOnlineAmount}
                                        validate={payOnlineAmountValidate}
                                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                                            payOnlineSubmit = handleSubmit; return (
                                                <form onSubmit={handleSubmit} noValidate>
                                                    <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                                        {getFormFieldAmount(values).map((item, idx) => item.visible ? (
                                                            <Grid item xs={item.size} key={idx}>
                                                                {item.field}
                                                            </Grid>
                                                        ) : null)}
                                                    </Grid>
                                                </form>
                                            )
                                        }}
                                    />
                                </div>
                            }

                            {bankList && bankList.length == 0 &&
                                <div className={classes.mtV2}>
                                    <Button variant="contained" className={classes.addBankButton} onClick={() => handleAddBankOpen()}>
                                        <AddIcon className={classes.addIcon} />Add Supplier’s Bank Account
                                    </Button>
                                </div>
                            }

                            {bankList && bankList.length > 0 &&
                                <div className={classes.mtV2} >
                                    <div className={classes.titleV2}>Account Details</div>
                                    {bankList && bankList.length > 0 && bankList.filter(v => v && v.is_default).map((bank) => {
                                        return (
                                            <div className={classes.bankDetailsDiv}>
                                                {bank && bank.acc_type && bank.acc_type == 'BANK'&&<><Grid container spacing={2}>
                                                    <Grid item xs={4}>
                                                        <div className={classes.bankValueDiv}>
                                                            <Typography className={classes.subTitleTxt}>Account Holder Name</Typography>
                                                            <Typography className={classes.valueTxt}>
                                                                {bank && bank.acc_holder_name ? bank.acc_holder_name.toLowerCase() : ""}
                                                            </Typography>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={classes.bankValueDiv}>
                                                            <Typography className={classes.subTitleTxt}>Account Number</Typography>
                                                            <Typography className={classes.valueTxt}>{bank && bank.acc_number ? bank.acc_number : ""}</Typography>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4} className={classes.alignEnd}>
                                                        {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                                                            <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                                                        {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                                                            <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={classes.bankValueDiv}>
                                                            <Typography className={classes.subTitleTxt}>Bank Name</Typography>
                                                            <Typography className={classes.valueTxt1}>
                                                                {bank && bank.bank_name ? bank.bank_name.toLowerCase() : ""}
                                                            </Typography>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={classes.bankValueDiv}>
                                                            <Typography className={classes.subTitleTxt}>IFSC Code</Typography>
                                                            <Typography className={classes.valueTxt1}>{bank && bank.ifsc_code ? bank.ifsc_code : ""}</Typography>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={6} className={classes.alignEnd} >
                                                        <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                                                            Change
                                                        </Button>
                                                    </Grid>
                                                </Grid></>}
                                                {bank && bank.acc_type && bank.acc_type == 'UPI'&&<>
                                                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                                        <div className={classes.bankValueDiv}>
                                                            <Typography className={classes.subTitleTxt}>UPI ID</Typography>
                                                            <Typography className={classes.valueTxtUPI}>
                                                                {bank && bank.upi_address ? bank.upi_address : ""}
                                                            </Typography>
                                                        </div>
                                                        <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                                            {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                                                                &nbsp;
                                                                <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                                                            {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                                                                &nbsp;
                                                                <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                                                                &nbsp;&nbsp;
                                                            <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                                                                Change
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                </>}
                                            </div>)
                                    }
                                    )}
                                </div>
                            }

                            {calledFromFlow != "singleTrip" &&
                                <>
                                    <div>
                                        <hr className={classes.hrV1} />
                                    </div>

                                    <div className={classes.mtV2}>
                                        <div className={classes.payOnlineTitle}>
                                            <div className={classes.titleV1}>Trip Details</div>
                                            <div className={classes.titleV1}>Amount Linked</div>
                                        </div>
                                        <div className={classes.divListing}>

                                            {trips && trips.map((tripId) => (
                                                checkedTrips.filter((checkedTrip) => checkedTrip.tripId == tripId).map((tripData) => (
                                                    <Card variant="outlined" raised="false" className={classes.cardV1}>
                                                        <CardContent className={classes.cardContentV1}>
                                                            <Grid container wrap="nowrap" justify="space-between" alignItems='center' className={classes.gridTextV1}>
                                                                <Grid item>
                                                                    {tripData.startLocation + " - " + tripData.destinationLocation}
                                                                </Grid>
                                                                <Grid item>
                                                                    {numberFormat(tripData.attributionAmount)}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container alignItems="center" wrap="nowrap" className={classes.gridTextV2}>
                                                                <Grid item>
                                                                    {tripData.params && tripData.params[0] ? tripData.params[0] : ""}
                                                                </Grid>
                                                                <FiberManualRecordIcon className={classes.dotV3} />
                                                                <Grid item>
                                                                    {tripData.params && tripData.params[1] ? tripData.params[1] : ""}
                                                                </Grid>
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                ))
                                            ))}

                                        </div>
                                    </div>
                                </>
                            }

                        </>
                    }

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >
                    {allocatedAmountTotal > 0 && screen == "chooseTrips" &&
                        <>
                            <div className={classes.mbV1}>
                                <div className={Number(allocatedAmountTotal) > Number(transactionLimitValue) ? classes.divAllocatedAmountError : classes.divAllocatedAmount} >
                                    <div className={Number(allocatedAmountTotal) > Number(transactionLimitValue) ? classes.amountTextError : classes.amountText}>Total Amount</div>
                                    <div className={Number(allocatedAmountTotal) > Number(transactionLimitValue) ? classes.divAmountError : classes.divAmount}>{numberFormat(allocatedAmountTotal)}</div>
                                </div>
                                {Number(allocatedAmountTotal) > Number(transactionLimitValue) &&
                                    <div className={classes.errorV2}>
                                        Total amount cannot be greater than&nbsp;{numberFormat(transactionLimitValue)}
                                    </div>
                                }
                            </div>
                        </>
                    }

                    <div className={classes.divAlignActions}>
                        {screen == "chooseTrips" &&
                            <>
                                {calledFromFlow == "onlinePayments" &&
                                    <Button variant="contained" className={classes.backButton} onClick={() => handleBackClick()}>
                                        Back
                                    </Button>
                                }
                                {calledFromFlow == "singleSupplier" &&
                                    <Button variant="contained" className={classes.backButton} onClick={() => handleClose()}>
                                        Close
                                    </Button>
                                }
                                <Button variant="contained" className={classes.payButton} classes={{ disabled: classes.payButtonDisabled }} onClick={() => handlePayOnlineClick()} disabled={payOnlineDisabled}>
                                    Pay Online
                                </Button>
                            </>
                        }

                        {screen == "selectSupplier" && vendorLedger && vendorLedger.length > 0 &&
                            <Button variant="contained" className={classes.backButton} onClick={() => handleClose()}>
                                Close
                            </Button>
                        }
                        {vendorLedger && vendorLedger.length ==0 && calledFromFlow == "onlinePayments" &&
                        <>
                            <Button variant="contained" className={classes.addCta} onClick={handleAddSupplierOpen} >
                            Add Supplier
                            </Button>
                        </>}

                        {screen == "payOnline" &&
                            <>
                                {calledFromFlow != "singleTrip" &&
                                    <Button variant="contained" className={classes.backButton} onClick={() => handlePayOnlineBackClick()}>
                                        Back
                                    </Button>
                                }
                                {calledFromFlow == "singleTrip" &&
                                    <Button variant="contained" className={classes.backButton} onClick={() => handleClose()}>
                                        Close
                                    </Button>
                                }
                                <Button variant="contained" className={classes.payButton} classes={{ disabled: classes.payButtonDisabled }} onClick={() => handlePayNowClick()} disabled={calledFromFlow == "singleTrip" ? (payNowDisabled || payOnlineError) ? true : false : payNowDisabled} >
                                    Pay Now
                                </Button>
                            </>
                        }
                    </div>
                </SideBarDialogActions>

            </Drawer>

            {/* ******************************** Dialog to edit trip amount (trip attribution amount.) ********************************  */}
            {tripAmountEditOpen &&
                <Dialog fullWidth={true} maxWidth='xs' onClose={handleEditAmountClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="trip-amount-edit-dialog-title" open={tripAmountEditOpen} className={classes.dialogV1} classes={{ paperWidthXs: classes.widthV1 }} >
                    <DialogTitle id="trip-amount-edit-dialog-title" className={classes.dialogTitleV1}>
                        <div className={classes.divAlignTitle} >
                            <div className={classes.divTitle} >
                                Enter Amount
                            </div>
                            <div>
                                <IconButton onClick={handleEditAmountClose}>
                                    <CloseIcon className={classes.closeIconV1} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers className={classes.dialogContentV1}>

                        <Grid container direction="column">

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridTitleDialog}>
                                <Grid item>
                                    Trip Details
                                </Grid>
                                <Grid item>
                                    Balance
                                </Grid>
                            </Grid>

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridContainerDialog}>

                                <Grid container direction="column" wrap="nowrap" classes={{ container: classes.containerWidth }}>
                                    <Grid item className={classes.gridRouteDialog}>
                                        <span>{selectedForEdit && selectedForEdit.startLocation ? selectedForEdit.startLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{selectedForEdit && selectedForEdit.destinationLocation ? selectedForEdit.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParamsDialog} >
                                        {selectedForEdit && selectedForEdit.params.length > 0 && selectedForEdit.params.map((paramData, index) => (
                                            <>
                                                <div>{paramData ? paramData : ""}</div>
                                                {index != selectedForEdit.params.length - 1 &&
                                                    <FiberManualRecordIcon className={classes.dotV2} />
                                                }
                                            </>
                                        ))}
                                    </Grid>
                                </Grid>

                                <Grid item className={classes.containerWidth}>
                                    <div className={classes.textBalance}>
                                        {selectedForEdit && selectedForEdit.tripBalance ? numberFormat(selectedForEdit.tripBalance) : numberFormat(0)}
                                    </div>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Form
                            onSubmit={onTripEditSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialTripAmountValues}
                            validate={editAmountValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripEditSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getAmountFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />

                    </DialogContent>
                    <DialogActions className={classes.dialogActionsV1} >
                        <Button variant="contained" className={classes.closeButton} onClick={handleEditAmountClose} >
                            Close
                        </Button>
                        <Button className={classes.saveButton} variant="contained" onClick={onTripEditSubmit} disabled={dialogConfirmDisabled} classes={{ disabled: classes.saveButtonDisabled }} >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {addBankDetails && <AddBankDetailsDialog type={"SUPPLIER"} selectedData={selectedVendor} open={addBankDetails} onClose={handleAddBankClose} onSave={handleAddBankSave} calledFrom={calledFromFlow} allocatedAmountSingleSupplier={allocatedAmountTotal} />}
            {selectBank && <BankDetailsSelectionDialog type={"SUPPLIER"} selectedData={selectedVendor} open={selectBank} onClose={handleSelectBankClose} onSave={handleSelectBankSave} calledFromInfo={calledFromFlow} allocatedAmountSingleSupplier={allocatedAmountTotal} />}
            {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
            {addPhoneNumber && <AddPhoneNumberDialog open={addPhoneNumber} type={"supplier"} onClose={addPhoneNumberDialogClose} onConfirm={addPhoneNumberDialogConfirm} entityData={selectedVendor} calledFromFlow={"onlinePaymentSupplier"} branchFlow={calledFromFlow} />}
            {addSupplierOpen && <AddSupplier open={addSupplierOpen} defaultName={null} defaultNumber={null} onClose={handleAddSupplierClose} onSave={handleSupplierSave} />}
            {customPGOpen && <DwebPaymentGateWayDialog open={customPGOpen} orderRequestData={orderRequestData} cashFreeOrderData={cashFreeOrderData} onClose={handleCustomPGClose} onSave={handleCustomPGConfirm} />}
        </>
    )
}

const PaySupplierSideBarWithRouter = withRouter(PaySupplierSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetTripSuggestionSupplier: (suggestionData, onSuccess, onError) => {
        dispatch(getTripSuggestionSupplier(suggestionData, onSuccess, onError))
    },
    dispatchGetVendorLedgerData: (data, onSuccess, onError) => {
        dispatch(getVendorLedgerData(data, onSuccess, onError))
    },
    dispatchGetBankDetails: (data, onSuccess, onError) => {
        dispatch(getBankDetails(data, onSuccess, onError))
    },
    dispatchGetPaymentLink: (data, onSuccess, onFailure) => { dispatch(getPaymentLink(data, onSuccess, onFailure)) },
    dispatchGetPaymentInitiate: (data, onSuccess, onFailure) => (dispatch(getPaymentInitiate(data, onSuccess, onFailure))),
    dispatchGetOnlinePaymentsConfig: (onSuccess, onFailure) => { dispatch(onlinePaymentsConfig(onSuccess, onFailure)) },
    dispatchGetUserDetails: (onSuccess, onFailure) => { dispatch(getUserDetails(onSuccess, onFailure)) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaySupplierSideBarWithRouter);